import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import Seo from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle, Send } from "lucide-react";

export default function Layout({ children }) {
  const { settings } = useSettings();
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0C0E]">
      <Analytics />
      <Seo />
      <Header />
      <main className="flex-1 pt-16 sm:pt-20">{children}</main>
      <Footer />
      {(settings.whatsapp || settings.telegram) && (
        <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
          {settings.whatsapp && (
            <a href={settings.whatsapp} target="_blank" rel="noreferrer" data-testid="float-whatsapp"
              className="h-12 w-12 rounded-full bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
              <MessageCircle className="text-white" size={22} />
            </a>
          )}
          {settings.telegram && (
            <a href={settings.telegram} target="_blank" rel="noreferrer" data-testid="float-telegram"
              className="h-12 w-12 rounded-full bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
              <Send className="text-white" size={20} />
            </a>
          )}
        </div>
      )}
    </div>
  );
}
